// src/Components/LoadingComp/LoadingScreen.js
import React from 'react';
import './loadingscreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <h1>EYE CARE CLINIC & OPTICAL</h1>
        <img
          src="/optical-logo.webp"
          alt="eye care clinic and optical"
          className="spinning-wheel"
          loading="lazy"
        />

      </div>
    </div>
  );
};

export default LoadingScreen;